// extracted by mini-css-extract-plugin
export default {"editButtons":"value_editButtons__Rmwez","editableValue":"value_editableValue__IPZFZ"};